export default {
  content: {
    minHeight: '100%',
  },
};
